import React from 'react';
import { StockChart, Tabs } from '@components';

function tabComp(props) {
  const {
    buyerName,
    targetName,
    selectedRange,
    changeRange,
    data: { buyer },
    isSingleCompany,
    ...rest
  } = props;

  return (
    <Tabs
      isSingleCompany={isSingleCompany}
      className="stock-tab-wrapper"
      defaultValue={0}
      tabs={[
        {
          label: buyerName,
          children: (
            <StockChart
              data={buyer}
              onRangeSelected={changeRange}
              selected={selectedRange}
              {...rest}
            />
          ),
        },
      ]}
    />
  );
}

export default tabComp;
